import { Component, ViewChild } from '@angular/core'
import { UiService } from 'src/app/services/ui.service'
import { AccountService, Integration } from '../../services/account.service'
import { handleArpioError } from 'src/utils/handle-error'
import { ApiService } from 'src/app/services/api.service'
import { ModalDialogComponent } from 'src/app/shared/modal-dialog/modal-dialog.component'
import { Subscription, of } from 'rxjs'
import { subscriptionActive } from 'src/utils/rxjs-utils'
import { delay, finalize } from 'rxjs/operators'

@Component({
  selector: 'account-integrations',
  templateUrl: './account-integrations.component.html',
  styleUrls: ['./account-integrations.component.scss'],
  standalone: false,
})
export class AccountIntegrationsComponent {
  @ViewChild('editIntegrationDialog', { static: true }) failoverDialog: ModalDialogComponent
  private integrationToEdit: Integration = null

  private savingSubscription: Subscription = null

  constructor(
    public accountService: AccountService,
    public uiService: UiService,
    private apiService: ApiService
  ) {}

  get integrations() {
    return this.accountService.integrations || []
  }

  get licensedForIntegrations() {
    return this.accountService.licensedForIntegrations
  }

  editIntegration(integration: Integration) {
    this.integrationToEdit = integration
    this.failoverDialog.open()
  }

  dismissEditModal() {
    this.integrationToEdit = null
    this.failoverDialog.close()
  }

  configureNewIntegration() {
    this.integrationToEdit = null
    this.failoverDialog.open()
  }

  commitIntegration(newIntegration: Integration) {
    this.savingSubscription = this.accountService
      .saveIntegration$(newIntegration)
      .pipe(finalize(() => (this.savingSubscription = null)))
      .subscribe((_) => this.failoverDialog.close())
  }

  get savingIntegration() {
    return subscriptionActive(this.savingSubscription)
  }

  deleteIntegration(integration: Integration) {
    this.accountService
      .deleteIntegration$(integration.integrationId)
      .subscribe(() => {}, handleArpioError(window.location.href, this.apiService, this.uiService))
  }
}
